import { loadQuery } from 'react-relay';
import { createResource, useResource } from 'react-resource-router';
import { HelpHelpCenterAri, HelpPageAri } from '@atlassian/ari';
import { __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__ } from '@atlassian/relay-environment-provider/environment';
function createCacheKey(query, variables) {
  var queryId = 'cacheID' in query.params ? query.params.cacheID : query.params.id;
  return "relay-".concat(queryId, "-").concat(query.params.name, "-").concat(JSON.stringify(variables !== null && variables !== void 0 ? variables : {}));
}
export var createRelayResource = function createRelayResource(_ref) {
  var getQuery = _ref.getQuery;
  return createResource({
    type: 'RELAY_RESOURCE_TYPE',
    getKey: function getKey(routerContext, customContext) {
      var _getQuery = getQuery(routerContext, customContext),
        query = _getQuery.query,
        variables = _getQuery.variables,
        cacheKey = _getQuery.cacheKey;
      return cacheKey !== null && cacheKey !== void 0 ? cacheKey : createCacheKey(query, variables);
    },
    getData: function getData(routerContext, customContext) {
      var _getQuery2 = getQuery(routerContext, customContext),
        query = _getQuery2.query,
        variables = _getQuery2.variables,
        options = _getQuery2.options;
      var queryReference = loadQuery(__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__, query, variables !== null && variables !== void 0 ? variables : {}, options);
      return Promise.resolve(queryReference);
    }
  });
};
export var useRelayResource = function useRelayResource(resource) {
  var _useResource = useResource(resource),
    queryReference = _useResource.data;
  return {
    queryReference: queryReference
  };
};
var getSafeHelpCenterIdMeta = function getSafeHelpCenterIdMeta(helpCenterAri) {
  try {
    if (helpCenterAri && helpCenterAri !== 'null' && HelpHelpCenterAri.check(helpCenterAri)) {
      var _HelpHelpCenterAri$pa = HelpHelpCenterAri.parse(helpCenterAri),
        activationId = _HelpHelpCenterAri$pa.activationId,
        helpCenterId = _HelpHelpCenterAri$pa.helpCenterId;
      return {
        activationId: activationId,
        helpCenterId: helpCenterId
      };
    }
  } catch (error) {
    // todo: add analytics
  }
};
export var getPageAri = function getPageAri(helpCenterAri, pageId) {
  var _ref2 = getSafeHelpCenterIdMeta(helpCenterAri) || {},
    _ref2$activationId = _ref2.activationId,
    activationId = _ref2$activationId === void 0 ? '' : _ref2$activationId,
    _ref2$helpCenterId = _ref2.helpCenterId,
    helpCenterId = _ref2$helpCenterId === void 0 ? '' : _ref2$helpCenterId;
  return HelpPageAri.create({
    activationId: activationId,
    pageId: pageId || helpCenterId
  }).toString() || '';
};